'use strict';

module.exports = /* @ngInject */ function () {
    return {
        restrict: 'E',
        scope: {
            targetInputElementId: '<',
            text: '=',
            category: '<'
        },
        templateUrl: `./${BUILD_PATH}/text-module.directive.html`,
        controller: /* @ngInject */ function ($scope, textModuleService, userService) {

            $scope.textModules = null;
            $scope.selectedTextModules = {};
            $scope.showTextModules = false;

            $scope.user = null;

            $scope.error = false;

            $scope.textModuleSelected = textModuleSelected;
            $scope.toggleTextModules = toggleTextModules;

            init();

            /**
             * initiates text-modules
             */
            function init() {
                const userPromise = getUser();
                const textModulePromise = getTextModules();
                Promise.all([userPromise, textModulePromise]).then(() => {
                    if ($scope.textModules) {
                        $scope.textModules.forEach((textModule) => {
                            const userLang = $scope.user.language.id;
                            const textModuleNameInUserLang = textModule.names.find((name) => name.language.id === userLang);
                            // find entry in the user language and sets its content as the preview text
                            let previewText = '';
                            textModuleNameInUserLang ?
                                previewText = textModuleNameInUserLang :
                                previewText = textModule.names[0];
                            $scope.selectedTextModules[textModule.id] =
                                previewText.length > 200 ?
                                    previewText.substr(0, 200) + '...' :
                                    previewText;
                        });
                        $scope.textModules = $scope.textModules.sort((a, b) => {
                            if (a.nameIntern.toLowerCase() > b.nameIntern.toLowerCase()) {
                                return 1;
                            } else if (a.nameIntern.toLowerCase() === b.nameIntern.toLowerCase()) {
                                return 0
                            }
                            return -1;
                        });
                        $scope.error = false;
                        $scope.$apply();
                    }
                }, (error) => {
                    $scope.error = true;
                    console.error(error);
                });
            }

            /**
             * Fetches the current logged in user from the API. The returned user consists of userId, firstname, lastname
             * and language.
             * @returns {Promise<unknown>}
             */
            function getUser() {
                return new Promise(((resolve, reject) => {
                    userService.getMyself.get().$promise
                        .then((user) => {
                            $scope.user = user;
                            resolve();
                        }, () => {
                            reject();
                        });
                }))
            }

            /**
             * Fetches textModules from Api if they are activated for the current user.
             * @returns {Promise<unknown>}
             */
            function getTextModules() {
                return new Promise((resolve, reject) => {
                    textModuleService.getTextModules.get({category: $scope.category}).$promise.then((textModules) => {
                        $scope.textModules = textModules;
                        resolve();
                    }, (error) => {
                        reject(error);
                    })
                }, (errorIsActivated) => {
                    reject(errorIsActivated);
                })
            }


            /**
             * Adds a textModule to the sourcing waiver comment textarea after its been selected.
             * @param selectedTextModule
             */
            function textModuleSelected(selectedTextModule) {
                if (selectedTextModule) {
                    if (typeof $scope.targetInputElementId !== 'undefined') {
                        let targetInputElement = document.getElementById($scope.targetInputElementId);
                        let text = targetInputElement.value;
                        text += (text ? '\n' : '') + selectedTextModule.text;
                        targetInputElement.value = text;
                        // we need to focus to refresh the textarea height
                        targetInputElement.focus();
                    } else if (typeof $scope.text !== 'undefined') {
                        $scope.text += ($scope.text ? '\n' : '') + selectedTextModule.text;
                    }
                    toggleTextModules();
                }
            }

            /**
             * Toggles the textModule table
             * @param event
             */
            function toggleTextModules(event) {
                if (event) {
                    event.preventDefault();
                }
                $scope.showTextModules = !$scope.showTextModules;
            }
        }
    };
}
